var cursor = '_16r7xlc1';
var scrubbing = '_16r7xlc0';

export { cursor, scrubbing };
//# sourceMappingURL=use-scrub.css.js.map
